//React Related & Redux
import React, { useState, useEffect } from "react"
import { Link as RouterLink } from "react-router-dom"
import axios from "axios"
//MUI
import { makeStyles } from "@material-ui/core/styles"
import MuiAlert from "@material-ui/lab/Alert/Alert"
import Snackbar from "@material-ui/core/Snackbar/Snackbar"
import Paper from "@material-ui/core/Paper"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
//My Components
import WideLayout from "../../layouts/WideLayout"
import Backdrop from "@material-ui/core/Backdrop"
import { withStyles } from "@material-ui/core/styles"
import FactorGenerator from "../../components/FactorGenerator/FactorGenerator"
import Loader from "../../components/Global/Loader/Index"

const StyledPaper = withStyles({
    root: {
        backgroundColor: "transparent",
        position: "relative",
        boxShadow: "none",
        paddingTop: "0",
    },
})(Paper);

const LimitedBackdrop = withStyles({
    root: {
        backgroundColor: "rgb(0, 0, 0,0.2)",
        height: "105%",
        position: "absolute",
        zIndex: 1,
        color: "#fff",
        borderRadius: "10px",
        marginTop: "-10px",
    },
})(Backdrop);

export function Alert(props) {
    return <MuiAlert elevation={6} severity="error" variant="contained" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    noBoxShadow: {
        boxShadow: "none",
    },
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1234,
        },
    },
    pad: {
        padding: "0 60px",
        [theme.breakpoints.down("sm")]: {
            padding: "0 20px",
        },
        [theme.breakpoints.down("xs")]: {
            padding: "0 0px",
        },
    },
    base: {
        flexGrow: 1,
        marginTop: "24px",
    },
    grayBox: {
        backgroundColor: "#f2f2f2",
        paddingTop: "30px",
    },
    textArea: {
        padding: "10px",
        borderRadius: "10px",
        backgroundColor: "#fff",
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "left",
        color: theme.palette.text.secondary,
    },
    stepLabel: {
        fontWeight: "700",
    },
    btnAdd: {
        backgroundColor: "#fff",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontWeight: "bold",
        color: "#3B3B3B",
        "&:hover": {
            backgroundColor: "#fff",
            paddingTop: "10px",
            paddingBottom: "10px",
        },
    },

    root: {
        display: "flex",
    },
    OutlinedDiv: {
        backgroundColor: "transparent",
        margin: "0,30px",
    },
    back: {
        width: "140px",
        backgroundColor: "#ffa000",
        fontWeight: "700",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#b28704",
        },
    },
    btnNext: {
        display: "block",
        minWidth: "140px",
        backgroundColor: "#28a504",
        fontWeight: "700",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#417557",
        },
    },
    img: {
        width: "130px",
        [theme.breakpoints.down("xs")]: {
            width: "100px",
        },
    },
    margin: {
        margin: "0px 10px 0px 10px",
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: "100%",
    },
    textWhite: {
        backgroundColor: "#fff",
    },
    btnInline: {
        display: "inline",
    },
    btnSave: {
        display: "inline",
        width: "172px",
        backgroundColor: "#28a504",
        marginLeft: "21px",
        fontWeight: "700",
        "&:hover": {
            backgroundColor: "#417557",
        },
    },
    smCenter: {
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
            width: "fit-content",
        },
    },
    textSm: {
        [theme.breakpoints.down("xs")]: {
            textAlign: "center",
            fontSize: "12px",
        },
    },
    inputNumber: {
        border: "none",
        width: "50px",
        textAlign: "center",
        fontSize: "17px",
        background: "#fff",
        paddingTop: "10px",
        [theme.breakpoints.down("xs")]: {
            width: "25px",
        },
    },
    green: {
        backgroundColor: "#417557",
        boxShadow: "none",
        color: "#fff",
        marginBottom: "20px",
        "&:hover": {
            background: "#447557",
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '15px',
            marginRight: '17px'
        },
    },
}));

const Unpaid = ({ history, match }) => {


    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [factorData, setFactorData] = useState({});
    const id = match.params.id

    const [isAlert, setIsAlert] = React.useState({
        type: "error",
        open: false,
        msg: "",
    });

    const handleAlert = (open, msg) => {
        setIsAlert({
            open: open,
            type: "fail",
            msg: msg,
        });
    };

    const bread = [
        { title: "صفحه اصلی", to: "/" },
        { title: "فاکتور سفارش", to: "/" },
    ];

    const sendAxios = async (body) => {
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.post(
                "/api/invoices/getinvoice",
                {
                    "invoiceId": id,
                },
                config
            )
            if (data.status === "Ok") {
                setFactorData(data.data);
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
        }
    };

    useEffect(() => {
        sendAxios()
    }, [])

    const handlePayment = async () => {
        try {
            let config = {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "content-type": "application/json",
                },
            };
            const { data } = await axios.post(
                "/api/invoices/payInvoice",
                {
                    invoiceId: factorData.invoiceNumber,
                },
                config
            );
            if (data.status === "ok") {
                document.location.href = `${data.data}`;
            }
        } catch (e) {
            console.log(e);
            handleAlert(true, "درخواست ناموفق بود");
        }
    };

    return (
        <>
            <WideLayout breadcrumbsItems={bread}>
                {loading ? (
                    <>
                        <Grid item xs={12}>
                            <Box mt={2}>
                                <Loader text={"در حال بارگزاری..."} />
                            </Box>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid
                            container
                            className={classes.base}
                            justify="center"
                            alignItems="center">
                            <Grid
                                justify="center"
                                alignItems="top"
                                className={classes.container}
                                container
                                spacing={1}>
                                <Grid item xs={12}>
                                    <Paper elevation={0} className={classes.paperNoBg}>
                                        <Box
                                            boxShadow={1}
                                            p={{ xl: 2, lg: 2, md: 2, sm: 0.5, xs: 0 }}
                                            m={1}
                                            borderColor="#f2f2f2"
                                            border={1}
                                            borderRadius={16}
                                            className={classes.noBoxShadow}>
                                            <Box
                                                borderRadius={10}
                                                bgcolor="#950000"
                                                p={1.5}
                                                fontWeight="bold"
                                                color="#fff">جزئیات فاکتور</Box>
                                            <FactorGenerator factor={factorData} confirm={true} />
                                        </Box>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <Paper elevation={0} className={classes.paperNoBg}>
                                        <Box
                                            fontWeight="bold"
                                            textAlign="center"
                                            color="#fff">

                                            <RouterLink to="/profile/unpaid-invoices">
                                                <span style={{ fontWeight: 'normal' }}>بازگشت به پروفایل</span>
                                            </RouterLink>&nbsp;&nbsp;&nbsp;
                                            <Button
                                                variant="contained"
                                                onClick={handlePayment}
                                                disabled={
                                                    factorData.totalPrice === "-" ? true : false
                                                }
                                                style={{ display: "inline" }}
                                                className={classes.btnNext}>
                                                پرداخت
                                                </Button>
                                        </Box>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                )}
            </WideLayout >
            <Snackbar
                open={isAlert.open}
                autoHideDuration={3300}
                onClose={() => handleAlert(false, isAlert.msg)}>
                <Alert>&nbsp;{isAlert.msg}</Alert>
            </Snackbar>
        </>
    );
};

export default Unpaid;
